import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const XIcon = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 24 23"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      {...rest}
    >
      <g fillRule="nonzero">
        <path d="m10.804 14.603-6.648 7.591H.473l8.611-9.837zM12.814 7.464 18.902.5h3.68L14.52 9.722z" />
        <path d="M24 22.194h-7.406L0 .5h7.594L24 22.194zm-6.39-2.203h2.039L6.486 2.587H4.298L17.61 19.991z" />
      </g>
    </svg>
  );
};

XIcon.displayName = 'XIcon';
